import { QueryParamsEnum } from '@honeycomb/data';
import { QueryParamManager } from '../utils/QueryParamManager';
import { router } from '../utils/router';
export function sortUpdatedRoute(sortCriterion) {
    const paramManager = new QueryParamManager(router.currentRoute() || '/', router.currentParams()); // to make this function pure, these values should be pass in as args
    paramManager.remove(QueryParamsEnum.SORT);
    if (sortCriterion) {
        paramManager.add(QueryParamsEnum.SORT, sortCriterion);
    }
    return [paramManager.toString(), undefined, { shallow: true }];
}
export function sortUpdatedRouting(sortCriterion) {
    router.push(sortCriterion, sortUpdatedRoute);
}
